import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { getDisplayRating } from '../../utils/ratingStars';

const HeroSection = ({
  restaurant,
  bannerImageUrl,
  renderStars,
  formatRating,
  isFavorite = false,
  onFavoriteClick,
}) => {
  const { t } = useTranslation();
  const displayRating = getDisplayRating(restaurant, 0);
  const offersPickup = restaurant?.accept_pickup === true;
  const isOpen = restaurant?.is_active !== false;

  const addressLine = [restaurant?.address, restaurant?.city].filter(Boolean).join(', ');

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ borderRadius: '0 0 clamp(30px, 4vw, 46px) clamp(30px, 4vw, 46px)', overflow: 'hidden' }}>
        <div
          style={{ width: '100%', aspectRatio: '21 / 7', backgroundColor: '#FBF9D9', backgroundImage: bannerImageUrl ? `url(${bannerImageUrl})` : undefined, backgroundSize: 'cover', backgroundPosition: 'center' }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 'clamp(16px, 3vw, 28px)', flexWrap: 'wrap', margin: '-54px 0 0', padding: '0 clamp(8px, 2vw, 32px)', position: 'relative' }}>
        <span style={{ flex: 'none', width: '116px', height: '116px', borderRadius: '999px', background: '#FBF9D9', border: '6px solid #FCFBF5', overflow: 'hidden', display: 'block' }}>
          <div style={{ width: '100%', height: '100%', backgroundImage: bannerImageUrl ? `url(${bannerImageUrl})` : undefined, backgroundSize: 'cover', backgroundPosition: 'center' }} />
        </span>
        <div style={{ flex: '1 1 260px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '10px', paddingBottom: '6px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <h1 style={{ margin: 0, fontFamily: 'Fraunces, Georgia, serif', fontWeight: 900, fontSize: 'clamp(24px, 3.6vw, 44px)', lineHeight: 1.15, letterSpacing: '-0.025em', background: '#054625', color: '#FBF9D9', padding: '8px 20px', borderRadius: '18px', boxShadow: '0 8px 20px rgba(5,16,4,0.25)' }}>
              {restaurant?.name || t('restaurant.fallbackName')}
            </h1>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: isOpen ? '#72B744' : 'rgba(5,16,4,0.72)', color: isOpen ? '#051004' : '#FCFBF5', fontFamily: 'Archivo, sans-serif', fontSize: '12.5px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '8px 15px', borderRadius: '999px' }}>
              {isOpen ? t('restaurant.open') : t('restaurant.closed')}
            </span>
            {restaurant?.is_certified && (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#054625', color: '#FBF9D9', fontFamily: 'Archivo, sans-serif', fontSize: '12.5px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '8px 15px', borderRadius: '999px' }}>
                ✓ {t('restaurant.certified')}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap', fontFamily: 'Archivo, sans-serif', fontSize: '14.5px', color: 'rgba(5,16,4,0.72)' }}>
            <span style={{ fontWeight: 600, color: '#054625' }}>★ {formatRating ? formatRating(displayRating) : displayRating.toFixed(1)}</span>
            <span>{t('restaurant.reviewCountLabel', { count: restaurant?.review_count || 0 })}</span>
            {restaurant?.cuisine_type && (<><span style={{ color: 'rgba(5,16,4,0.3)' }}>·</span><span>{restaurant.cuisine_type}</span></>)}
            {addressLine && (<><span style={{ color: 'rgba(5,16,4,0.3)' }}>·</span><span>{addressLine}</span></>)}
            <span style={{ color: 'rgba(5,16,4,0.3)' }}>·</span>
            <span style={{ color: '#054625', fontWeight: 600 }}>{offersPickup ? t('restaurant.deliveryAndPickup') : t('restaurant.delivery')}</span>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', paddingBottom: '8px' }}>
          <button
            type="button"
            onClick={onFavoriteClick}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '14.5px', padding: '11px 24px', borderRadius: '999px', border: 'none', background: isFavorite ? '#054625' : '#EF4C23', color: isFavorite ? '#FBF9D9' : '#FCFBF5' }}
          >
            {isFavorite ? <FaHeart className="w-4 h-4" /> : <FaRegHeart className="w-4 h-4" />}
            {isFavorite ? t('restaurant.following') : t('restaurant.follow')}
          </button>
        </div>
      </div>
      <p style={{ margin: '26px clamp(8px, 2vw, 32px) 0', fontSize: '16.5px', lineHeight: 1.65, maxWidth: '68ch', color: 'rgba(5,16,4,0.8)' }}>
        {restaurant?.description || t('restaurant.defaultDescription')}
      </p>
    </div>
  );
};

export default HeroSection;
